import { get, post, del, toastErrorHandle, uploadFile } from './http-methods';
import { mapEntity as mapReleaseEntity } from './releases';

export const STEPS = [
  'PRODUCT_CATALOG',
  'PRODUCT_COMPETITIVES',
  'MATERIAL_RESISTANCE',
  'EDITOR2_MAPPINGS',
  'MATERIAL_DESCRIPTIONS',
  'MATERIAL_DESCRIPTIONS_PXC',
  'NEO_LASER_PARAMS',
  'PRIME_DETECTION_PARAMS',
  'PRODUCT_FILTER',
  'PRODUCT_TRANSLATIONS',
  'PRODUCT_IMAGES',
  'MARKETING_SLIDESHOWS',
  'MARKETING_IMAGES',
  'APP_TRANSLATIONS',
];

export const STEP_GROUPS = {
  catalog: [
    'PRODUCT_CATALOG',
    'PRODUCT_COMPETITIVES',
    'MATERIAL_RESISTANCE',
    'EDITOR2_MAPPINGS',
    'MATERIAL_DESCRIPTIONS',
    'MATERIAL_DESCRIPTIONS_PXC',
    'NEO_LASER_PARAMS',
    'PRIME_DETECTION_PARAMS',
  ],
  dependencies: ['PRODUCT_FILTER', 'PRODUCT_TRANSLATIONS'],
  other: [
    'PRODUCT_IMAGES',
    'MARKETING_SLIDESHOWS',
    'MARKETING_IMAGES',
    'APP_TRANSLATIONS',
  ],
};

const ZIP_FILES = [
  'MATERIAL_DESCRIPTIONS',
  'MATERIAL_DESCRIPTIONS_PXC',
  'APP_TRANSLATIONS',
  'PRODUCT_IMAGES',
  'MARKETING_IMAGES',
  'MARKETING_SLIDESHOWS',
];

const AUTO_GENERATED = ['PRODUCT_FILTER', 'PRODUCT_TRANSLATIONS'];

const getExtName = (type) =>
  ZIP_FILES.indexOf(type) === -1 ? '.xlsx' : '.zip';

const mapFileEntity = (data) => ({
  id: data.id,
  name: data.name,
  type: data.type,
  extName: getExtName(data.type),
  status: data.status,
  readyToGenerate:
    AUTO_GENERATED.indexOf(data.type) !== -1 && data.status === 'OUTDATED',
  path: data.path,
  createdAt: data.created_at ? new Date(data.created_at) : null,
});

export const sortFileEntity = (a, b) =>
  STEPS.indexOf(a.type) - STEPS.indexOf(b.type);
const sortLogEntity = (a, b) => STEPS.indexOf(a.step) - STEPS.indexOf(b.step);
const LOG_STATUSES = ['INFO', 'WARNING', 'ERROR'];

const mapLogEntity = (data) => ({
  id: data.id,
  step: data.step,
  logs: data.logs,
  status: data.logs
    .reduce(
      (acc, log) =>
        LOG_STATUSES.indexOf(log.status) < LOG_STATUSES.indexOf(acc)
          ? acc
          : log.status,
      'SUCCESS'
    )
    .toLowerCase(),
  file: data.file,
});

export default {
  getRelease() {
    return get('/versions/releases/current').then(({ json }) => ({
      release: mapReleaseEntity(json.data, []),
      files:
        (json &&
          json.included &&
          json.included.files &&
          json.included.files.map(mapFileEntity).sort(sortFileEntity)) ||
        [],
    }));
  },
  getDraftStatus() {
    return get('/versions/draft/status').then(({ json }) => ({
      status: json.data.status,
      files: json.data.files.map(mapFileEntity).sort(sortFileEntity),
      activeSteps: json.data.active_steps || [],
    }));
  },
  getDraftLogs() {
    return get('/versions/draft/logs').then(({ json }) => {
      if (json.data === null) {
        return { logs: null, startedAt: null };
      }

      return {
        logs: json.data.logs.sort(sortLogEntity).map(mapLogEntity),
        startedAt: new Date(json.data.started_at),
      };
    });
  },
  uploadDraftFile(key, file, onProgress) {
    return uploadFile(`/versions/draft/files/${key}`, file, onProgress);
  },
  deleteDraftFile(key) {
    return del(`/versions/draft/files/${key}`).then((resp) =>
      resp.status === 204 ? null : toastErrorHandle(resp)
    );
  },
  runDBCheck() {
    return post('/versions/draft/check').then((resp) =>
      resp.status === 200 ? null : toastErrorHandle(resp)
    );
  },
  runDBRelease(clientUpdateValue) {
    return post('/versions/draft/release', {
      client_update_req: clientUpdateValue,
    }).then((resp) => {
      resp.status === 200 ? null : toastErrorHandle(resp);
    });
  },
  autoGenerateFiles(keys) {
    let payload = keys.reduce((acc, key) => {
      let k = {
        PRODUCT_FILTER: 'isFiltersGenerate',
        PRODUCT_TRANSLATIONS: 'isTranslationsGenerate',
      }[key];
      acc[k] = true;
      return acc;
    }, {});
    return post('/versions/draft/generate', payload).then(
      (resp) => (resp.status === 204 ? null : Promise.reject(resp)),
      Promise.reject
    );
  },
};
